<!-- 供应商应付款分析 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-form :inline="true" label-width="100px" :model="getRequestData" class="demo-form-inline dis" size="mini">
                    <el-row>
                        <el-form-item label="开始日期">
                            <label slot="label" :style="$common.labelStyle('开始日期')" v-html="'开始日期'"></label>
                            <el-date-picker size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" class="form_codition" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期">
                            <label slot="label" :style="$common.labelStyle('结束日期')" v-html="'结束日期'"></label>
                            <el-date-picker size="mini" v-model="getRequestData.end" @change="changeTime" class="form_codition" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <!-- 检索方案 -->
                        <el-form-item label="购进单位名称">
                            <label slot="label" :style="$common.labelStyle('购进单位名称')" v-html="'购进单位名称'"></label>
                            <el-input clearable v-model="getRequestData.smName" class="form_codition" @keyup.enter.native="openSearch('3386264207560704', 0, 'smName','smId,smName')">
                                <el-button @click="openSearch('3386264207560704', 0, 'smName','smId,smName')" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="货主名称">
                            <label slot="label" :style="$common.labelStyle('货主名称')" v-html="'货主名称'"></label>
                            <el-input clearable v-model="getRequestData.coName" class="form_codition" @keyup.enter.native="openSearch('4414428383875072', 0, 'coName','coId,coName')">
                                <el-button @click="openSearch('4414428383875072', 0, 'coName','coId,coName')" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" size="mini" icon="el-icon-search" @click="searchData">查询</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-share" @click="exportExcel">导出</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <u-table size="mini" id="tableData" :data="dataShow" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" show-summary :summary-method=" getSummaries" stripe ref="stockTable"
                     :header-cell-style="{background:'#fff'}" :row-height="35" row-key="index" use-virtual>
                <u-table-column align="center" show-overflow-tooltip prop="unitName" label="单位名称" min-width="160"></u-table-column>
                <u-table-column align="center" show-overflow-tooltip prop="coName" label="货主名称" min-width="160"></u-table-column>
                <u-table-column align="center" show-overflow-tooltip prop="payDay" label="应付天数" :sortable="true" min-width="100"></u-table-column>
                <u-table-column align="center" show-overflow-tooltip label="期初">
                    <u-table-column align="center" show-overflow-tooltip prop="beginPay" label="应付" :sortable="true" min-width="120">
                    </u-table-column>
                    <u-table-column align="center" show-overflow-tooltip prop="beginPrePay" label="预付" :sortable="true" min-width="120">
                    </u-table-column>
                </u-table-column>
                <u-table-column align="center" show-overflow-tooltip label="本期">
                    <u-table-column align="center" show-overflow-tooltip prop="currentBuy" label="购进" :sortable="true" min-width="120">
                    </u-table-column>
                    <u-table-column align="center" show-overflow-tooltip prop="currentPay" label="付款" :sortable="true" min-width="120">
                    </u-table-column>
                    <u-table-column align="center" show-overflow-tooltip prop="currentPrePay" label="预付" :sortable="true" min-width="120">
                    </u-table-column>
                    <u-table-column align="center" show-overflow-tooltip prop="currentUsePrePay" label="使用预付款" :sortable="true" min-width="120">
                    </u-table-column>
                </u-table-column>
                <u-table-column align="center" show-overflow-tooltip label="期末">
                    <u-table-column align="center" show-overflow-tooltip prop="endPay" label="应付" :sortable="true" min-width="120"></u-table-column>
                    <u-table-column align="center" show-overflow-tooltip prop="endPrePay" label="预付" :sortable="true" min-width="120">
                    </u-table-column>
                    <u-table-column align="center" show-overflow-tooltip prop="endBalance" label="余额" :sortable="true" min-width="120">
                    </u-table-column>
                </u-table-column>
            </u-table>
        </div>
        <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
    name: "dataQueryTemplate",
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                smName: '',
                smId: '',
                coName: '',
                coId: '',
                salesName: '',
                salesId: '',
                page: 1,
                rows: 10
            },
            activeName: "0",
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
                pageSize: 10
            },
            selectedDataIndex: 0,
            reportConditionVos: [],
            reportModuleVos: [],
            tabIndex: 0,
            total: null,
            totalPageData: [],
            seId: '',
            seIndex: '',
            sField: '',
            parentSearchData: {},
            seTitle: "",//检索
            DialogVisible: false,
            seWidth: '0',
            seType: '',

            // 分页数据,这里用来保存每页切割后的数据
            // 看起来格式是这样的[[{},{},{}],[{},{},{}]]
            // 数组内套数组，每个数组就是一页数据
            totalPageData: [],
            // 共几页
            pageNum: 1,
            // 每页显示数量
            pageSize: 10,
            // 当前显示页码
            currentPage: 1,
            // 总共多少条数据
            total: 1,
            // 当前要显示的数据
            pageSizes: [10, 200, 500, 2000, 5000, 10000],
            dataShow: [],
            list: [],
            excelData: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.coName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.coId = "";
                }
            },
            deep: true,
        },
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.smId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'smName') this.parentSearchData.smId = val.smId
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName' && this.getRequestData.smId == '') {
                return this.$message({
                    message: '请先选择购进单位',
                    type: "warning",
                });
            }
            this.DialogVisible = true
            this.seType = type
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //获取当天最后时间戳
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },
        toDetail(orderId) {
            console.log(orderId);
            this.$parent.toDetail(orderId);
            //    this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        //触发按钮点击下载事件
        exportExcel() {
            this.excelData = this.list; //将你要导出的数组数据（historyList）赋值给excelDate
            this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
        },
        //表格数据写入excel
        export2Excel() {
            this.rpmName = '供货商应付款分析'; //获取当前导出表格标题
            var nameList = ['单位名称', '货主', '应付天数','期初应付', '期初预付', '本期购进', '本期付款', '本期预付', '本期使用预付款', '期末应付', '期末预付', '期末余额']; //表格头 显示的所有字段
            var fieldList = ['unitName', 'coName','payDay', 'beginPay', 'beginPrePay', 'currentBuy', 'currentPay', 'currentPrePay', 'currentUsePrePay', 'endPay', 'endPrePay', 'endBalance']; //所有字段 显示的所有字段
            var timeList = []; //date类型的字段 导出之前进行格式转换
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                const tHeader = nameList; // 导出的excel表头名信息
                const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                const list = this.list; // 查询的数据list
                // 进行数据json map 格式转换
                const data = this.formatJson(filterVal, list);
                // 调用方法传参      表头名信息 数据  导出的表格名称
                export_json_to_excel(tHeader, data, this.rpmName);
            });
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        //表格求和
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (index >= 1) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0);
                        sums[index] = this.$common.getDecimalInfo(9, sums[index])
                        // sums[index] += ' 元';
                    } else {
                        sums[index] = 'N/A';
                    }
                }
            });
            this.$nextTick(() => {
                this.$refs.stockTable.doLayout()
            })
            return [sums];
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.supplyOwnerPaystatic(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.list = responseData.result
                this.total = this.list.length;
                this.calcPageData();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 前端分页逻辑
        calcPageData() {
            // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
            if (this.list.length > 1) {
                this.pageNum = Math.ceil(this.list.length / this.pageSize) || 1;
            }
            // 数据分组
            for (let i = 0; i < this.pageNum; i++) {
                // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                this.totalPageData[i] = this.list.slice(
                    this.pageSize * i,
                    this.pageSize * (i + 1)
                );
            }
            // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
            this.dataShow = this.totalPageData[this.currentPage - 1];
            // this.fullscreenLoading = false
        },
        getList() {
            //过滤分页
            this.returnData.list = list.filter(
                (item, index) =>
                    index < this.page * this.limit &&
                    index >= this.limit * (this.page - 1)
            );
            //分页的总数据
            this.total = list.length;
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.dataShow = this.totalPageData[val - 1];
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.pageSize = val;
            // 重新计算页数并分组
            this.calcPageData();
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
        }
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
        })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
    overflow-y: auto;
}

.dis {
    display: flex;
    flex-wrap: wrap !important;
}
</style>